import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgMyActivity = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.75 6.5a.75.75 0 0 1 .75-.75H21a.75.75 0 0 1 .75.75V12a.75.75 0 0 1-1.5 0V8.31l-6.513 6.513a1.75 1.75 0 0 1-2.474 0l-3.086-3.086a.25.25 0 0 0-.354 0L3.53 16.03a.75.75 0 0 1-1.06-1.06l4.293-4.293a1.75 1.75 0 0 1 2.474 0l3.086 3.086a.25.25 0 0 0 .354 0l6.512-6.513H15.5a.75.75 0 0 1-.75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgMyActivity;
